module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-view"
  }, [_c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require('../assets/img/cuelistBLACK.png'),
      "alt": "Cuelist Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "email-login"
  }, [(_vm.signingIn) ? _c('h2', {
    staticClass: "email-login-title"
  }, [_vm._v("Sign in with email")]) : _c('h2', {
    staticClass: "email-login-title"
  }, [_vm._v("Register with email")]), _vm._v(" "), (_vm.signingIn) ? _c('login-form', {
    ref: "loginForm",
    on: {
      "toggle-register": _vm.toggleRegister,
      "sso-login": _vm.login,
      "attempt": function($event) {
        _vm.signInError = ''
      }
    }
  }) : _c('register-form', {
    on: {
      "toggle-register": _vm.toggleRegister,
      "success": _vm.createUser
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.signingIn) ? _c('div', {
    staticClass: "sso-login"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary google-button",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.login
    }
  }, [_c('img', {
    staticClass: "google-icon",
    attrs: {
      "src": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg",
      "alt": "Google"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Continue with Google")])]), _vm._v(" "), (_vm.signInError) ? _c('p', {
    staticClass: "signin-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.signInError))]) : _vm._e()], 1) : _c('div', {
    staticClass: "sso-login"
  }, [_c('h2', [_vm._v("Register with Google")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary google-button",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.login
    }
  }, [_c('img', {
    staticClass: "google-icon",
    attrs: {
      "src": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg",
      "alt": "Google"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Continue with Google")])]), _vm._v(" "), (_vm.signInError) ? _c('p', {
    staticClass: "signin-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.signInError))]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('core-footer'), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "loginSSODialog",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.getConfirmContent(),
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.onDialogClose
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("or")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms-container"
  }, [_c('p', {
    staticClass: "terms-text"
  }, [_vm._v("\n                By registering for and/or signing into Cuelist you signify your acceptance of both our \n                "), _c('a', {
    attrs: {
      "href": "https://thecuelist.com/terms-of-use",
      "target": "_blank"
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" and \n                "), _c('a', {
    attrs: {
      "href": "https://thecuelist.com/privacy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4140b2e8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login.vue
// module id = 1231
// module chunks = 21